import moment from 'moment';
import _ from 'lodash';
export const formatting = {
    methods : {
        dateFormat : function (d, format) {
            if (!d) {
                return '';
            }
            var date = moment(d);
            if (date.isValid()) {
                return date.format(format);
            }
            return d;
        },
        fuzzyDate : function (d) {
            if (!d) {
                return 'Never';
            }
            var date = moment(d);
            if (date.isValid()) {
                var current = moment();
                var duration = moment.duration(date.diff(current));
                return duration.humanize(true);
            }
            return d;
        },
        moneyFormat : function (v) {
            if (!v) {
                v = 0;
            }
            var n = parseFloat(v);
            return n.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
        },
        nl2br : function (str) {
            if (typeof str === 'undefined' || str === null) {
                return '';
            }
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
        }
    },
    filters : {
        titlecase : function (str) {
            return _.startCase(str);
        },
        nl2br : function (str) {
            if (typeof str === 'undefined' || str === null) {
                return '';
            }
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
        },
        showTime : function (d) {
            if (!d) {
                return '';
            }
            var date = moment(d);
            if (date.isValid()) {
                return date.format('DD MMM YYYY, h:mma');
            }
            return '';
        },
        fileSize : function (bytes) {
            var kilo = 1000;
            bytes = parseInt(bytes);
            if(Math.abs(bytes) < kilo) {
                return bytes + ' B';
            }
            var units = ['kB','MB','GB','TB','PB','EB','ZB','YB'];
            var u = -1;
            do {
                bytes /= kilo;
                ++u;
            } while(Math.abs(bytes) >= kilo && u < units.length - 1);
            return bytes.toFixed(1) + ' ' + units[u];
        }
    }
};
